import {
  Beaker16Regular,
  Beaker24Regular,
  Bot16Regular,
  Bot24Regular,
  CalendarLtr16Regular,
  CalendarLtr24Regular,
  Chat16Regular,
  Chat24Regular,
  Clock16Regular,
  Clock24Regular,
  Code16Regular,
  Code24Regular,
  Document16Regular,
  Document24Regular,
  Lightbulb16Regular,
  Lightbulb24Regular,
  Mail16Regular,
  Mail24Regular,
  Notebook16Regular,
  Notebook24Regular,
} from '@/components/Icon'

export const workspaceIconPackB = {
  mail: { 16: Mail16Regular, 24: Mail24Regular },
  calendar: { 16: CalendarLtr16Regular, 24: CalendarLtr24Regular },
  clock: { 16: Clock16Regular, 24: Clock24Regular },
  chat: { 16: Chat16Regular, 24: Chat24Regular },
  bot: { 16: Bot16Regular, 24: Bot24Regular },
  lightbulb: { 16: Lightbulb16Regular, 24: Lightbulb24Regular },
  beaker: { 16: Beaker16Regular, 24: Beaker24Regular },
  code: { 16: Code16Regular, 24: Code24Regular },
  document: { 16: Document16Regular, 24: Document24Regular },
  notebook: { 16: Notebook16Regular, 24: Notebook24Regular },
}
